import { MODELS } from '../data/models';
import { SYNTH_MODES } from '../data/synth-modes';
import { OPTIMAL_META_PROMPT } from '../data/optimal-meta-prompt';
import { state, savedState } from './state';
import { t, getCurrentLang } from './i18n';
import { copyToClipboard } from './ui-helpers';
import { toast } from './toast';
import { addSpent, calcCost } from './cost-tracking';
import { callModel } from '../api';
import { mountExportMenu, buildOptimalPromptMarkdown } from './exports';
import { updateRunButton } from './runner';

/* =================================================================
   11c. Optimal Prompt — reverse-engineered from the synthesis
   ================================================================= */
export function attachOptimalPromptHandlers() {
  document.getElementById("optimal-btn").addEventListener("click", async () => {
    if (!savedState.lastSynthText) { toast(t("save.nothing")); return; }
    const synthModel = MODELS.find(m => m.id === savedState.lastSynthModelId);
    if (!synthModel) return;

    const ok = state.lastResponses.filter(r => r.ok);
    const responsesBlock = ok.map((r, i) => {
      const m = MODELS.find(x => x.id === r.modelId);
      return `--- Model ${i+1} (${m ? m.label : r.modelId}) ---\n${r.text}\n`;
    }).join("\n");

    const meta = (OPTIMAL_META_PROMPT[getCurrentLang()] || OPTIMAL_META_PROMPT.en)
      .replace("{prompt}", state.lastPrompt)
      .replace("{responses}", responsesBlock)
      .replace("{synthesis}", savedState.lastSynthText);

    const btn = document.getElementById("optimal-btn");
    const outEl = document.getElementById("optimal-output");
    const actions = document.getElementById("optimal-actions");
    btn.disabled = true;
    const oldLabel = btn.querySelector("span").textContent;
    btn.querySelector("span").textContent = t("optimal.generating");
    outEl.value = "";
    outEl.setAttribute("readonly", "");
    actions.style.display = "none";

    try {
      const r = await callModel(synthModel, meta);
      addSpent(savedState.lastSynthModelId, calcCost(savedState.lastSynthModelId, r.inTokens, r.outTokens));
      const cleaned = (r.text || "").trim().replace(/^["'`]+|["'`]+$/g, "");
      outEl.value = cleaned;
      savedState.lastOptimalPrompt = cleaned;
      actions.style.display = "";
    } catch (err) {
      outEl.value = "";
      toast(err.message || String(err));
    } finally {
      btn.disabled = false;
      btn.querySelector("span").textContent = oldLabel;
    }
  });

  document.getElementById("optimal-edit").addEventListener("click", () => {
    const out = document.getElementById("optimal-output");
    if (out.hasAttribute("readonly")) {
      out.removeAttribute("readonly");
      out.focus();
      document.getElementById("optimal-edit").querySelector("span").textContent = t("optimal.editing");
    } else {
      out.setAttribute("readonly", "");
      savedState.lastOptimalPrompt = out.value;
      document.getElementById("optimal-edit").querySelector("span").textContent = t("optimal.edit");
    }
  });

  document.getElementById("optimal-copy").addEventListener("click", async () => {
    const out = document.getElementById("optimal-output");
    const ok = await copyToClipboard(out.value);
    toast(ok ? t("copy.done") : t("copy.failed"));
  });

  mountExportMenu(
    document.getElementById("optimal-save"),
    ["md", "docx", "pdf"],
    () => {
      const text = document.getElementById("optimal-output").value;
      if (!text) return null;
      const md = buildOptimalPromptMarkdown(text, savedState.lastSynthMode);
      const modeLabel = SYNTH_MODES[savedState.lastSynthMode]?.labels[getCurrentLang()] || savedState.lastSynthMode;
      const sections = [
        { heading: t("export.section.original"), markdown: state.lastPrompt },
        {
          heading: t("export.section.optimal"),
          subhead: t("export.section.optimal.sub", { mode: modeLabel }),
          markdown: text,
        },
      ];
      return { title: "Lorenza · Optimal Prompt", markdown: md, sections };
    },
    "lorenza-optimal-prompt"
  );

  document.getElementById("optimal-use").addEventListener("click", () => {
    const text = document.getElementById("optimal-output").value;
    if (!text) { toast(t("save.nothing")); return; }
    const promptInput = document.getElementById("prompt-input");
    const charCount = document.getElementById("char-count");
    promptInput.value = text;
    charCount.textContent = text.length;
    updateRunButton();
    promptInput.scrollIntoView({ behavior: "smooth", block: "center" });
    promptInput.focus();
    toast(t("optimal.used"));
  });
}
